var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-animation"},[_c('div',{staticClass:"animation-element"},[_c('div',{staticClass:"element-inner"})]),_c('div',{staticClass:"animation-element"},[_c('div',{staticClass:"element-inner"})]),_c('div',{staticClass:"animation-element"},[_c('div',{staticClass:"element-inner"})])])
}]

export { render, staticRenderFns }